import {
  blocksFontCSS,
  sansSerifStyles
} from "@pathwright/blocks/src/ui/typography"
import styled from "styled-components"

const GridContainer = styled.div`
  .MatchingEditor__container,
  .MatchingEditor__header,
  .MatchingEditor__new-items {
    display: grid;
    grid-template-columns: 15px 1fr 1fr 15px;
    column-gap: 1rem;
    row-gap: 0.5rem;

    @media (max-width: 768px) {
      column-gap: 0.5rem;
    }
  }
`

const GridItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const MatchingEditor = styled(GridContainer)``

export const MatchingEditorContainer = styled.div``

export const MatchingEditorHeader = styled.div``

export const MatchingEditItemWrap = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 3px;

  .chakra-input {
    padding: 0;
    height: 100%;
    outline: none;
    border: none;
    &.focus-visible {
      box-shadow: none;
      border: none !important;
    }
  }

  .MatchingMatchInput {
    ${sansSerifStyles()}

    &::placeholder {
      font-style: italic;
    }
  }
`

export const MatchingViewer = styled(GridContainer)`
  margin-top: 0.5rem;

  // Thank you, highly specific ReactSelect styles
  .Select.has-value.Select--single
    > .Select-control
    .Select-value
    .Select-value-label {
    color: ${(p) => p.textColor};
  }

  .Select.is-disabled * {
    cursor: not-allowed;
  }
`

export const MatchingEditRowWrap = styled(GridItem)`
  display: grid;
  grid-template-columns: 15px 1fr 1fr 15px;
  grid-column-gap: 1rem;
  padding: 0.5rem 0;

  @media (max-width: 768px) {
    grid-column-gap: 0.5rem;
  }

  ${blocksFontCSS()}

  ${(p) =>
    p.disabled
      ? `
  transform: none !important;

  `
      : ``}

  .ql-container {
    font-size: 16px;

    @media (max-width: 768px) {
      font-size: 14px;
    }

    .ql-tooltip {
      /* Having to set this b/c of the display: inline-block on the QuillEditor */
      width: 156px !important;
    }

    .ql-editor {
      min-width: 70px;
      @media (min-width: 541px) {
        min-width: 125px;
      }

      p {
        word-break: break-word;
      }
    }
  }

  ${(p) =>
    !p.isMobile
      ? `
    .MatchingDeleteButton,
    .MatchingHandle {
      opacity: 0;
      transition: opacity 0.2s;
    }
  `
      : ``}

  &:hover {
    .MatchingDeleteButton,
    .MatchingHandle {
      opacity: 1;
    }
  }
`

export const MatchingDeleteComponent = styled(MatchingEditItemWrap)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  padding: 0.6rem 1rem;
  width: calc(100% - 62px);

  @media (max-width: 768px) {
    width: calc(100% - 46px);
  }

  margin: 8px auto;
  font-size: 14px;
`

export const MatchingViewerItemWrap = styled(GridItem)`
  padding: 15px 0 15px 10px;
  margin: 0;
  position: relative;
  border: 1px solid transparent;

  ${blocksFontCSS()}

  .BlockText {
    padding: 1px 0.5rem 1px 0;
  }

  @media (min-width: 769px) {
    padding: 10px 0 10px 10px;
    margin: 0;
    .BlockText {
      padding-right: 1rem;
    }
  }

  .BlockText p,
  .ContentText {
    margin: 0;
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .Select-value {
    padding-right: 20px !important;
  }

  .Select.is-disabled {
    margin-right: 15px;

    @media (min-width: 769px) {
      margin-right: 0;
    }

    .Select-value {
      border: 1px solid #ccc;

      .Select-value-label {
        color: #333 !important;
      }
    }

    .Select-arrow-zone {
      /* opacity: 0; */
    }
  }

  /* &::after {
    content: "";
    font-family: "pathicons";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  } */
`

export const MatchingDragHandle = styled.div`
  /* position: absolute;
  left: -18px; */
`
